import useTrainingSettings from './useTrainingSettings';
import useDocuments from './useDocuments';
import useAuth from './useAuth';
import { useEffect, useMemo } from 'react';

const useTrainingComplete = () => {
  const { user } = useAuth();
  const { settings } = useTrainingSettings();
  const { documents, getMyDocuments } = useDocuments();

  useEffect(() => {
    if (user.account_type !== 'ADMIN') {
      getMyDocuments();
    }
  }, [user.account_type, getMyDocuments]);

  const isInsuranceExists = useMemo(() => {
    return documents.some(
      (document) => document.document_type_name === 'INSURANCE'
    );
  }, [documents]);

  const isLicenseExists = useMemo(() => {
    return documents.some(
      (document) => document.document_type_name === 'DRIVERS LICENSE'
    );
  }, [documents]);

  const trainingComplete = useMemo(() => {
    if (!user.is_safety_program_enabled) return true;

    // Organization team admins are exempt from course completion, matching
    // the backend checkTraining middleware. They still need the required
    // documents when the team's training settings require them.
    const isTeamAdmin = user.is_admin && user.account_type !== 'ADMIN';
    if (isTeamAdmin) {
      return settings.is_documents_required_for_training
        ? user.is_required_documents_for_training_uploaded
        : true;
    }

    return settings.is_documents_required_for_training
      ? user.is_done_training &&
          user.is_required_documents_for_training_uploaded
      : user.is_done_training;
  }, [user, settings, documents]);

  return {
    trainingComplete,
    isInsuranceExists,
    isLicenseExists,
    isDoneTraining: user.is_done_training,
    isSafetyProgramEnalbed: user.is_safety_program_enabled,
    isDocumentsRequiredForTraining: settings.is_documents_required_for_training,
  };
};

export default useTrainingComplete;
